import styled from "styled-components";
import { V3Caption } from "../Typography";

export const PaginationWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PaginationNumber = styled(V3Caption) <{ selected: boolean }>`
    padding: 10px 16px;
    border-radius: 4px;
    background: ${({ selected, theme }) => selected ? theme.colors.dodgerBlue : "100%"};
    color: ${({ selected }) => selected ? "white" : null};

    &:hover {
        cursor: pointer;
        background: ${({ selected, theme }) => selected ? null : theme.colors.blackPearl5};
        color: ${({ selected, theme }) => selected ? null : theme.colors.dodgerBlue};
        border-radius: 4px;
    }
`;

export const PaginationArrow = styled.img` 
    display: block;
    width: 28px;

    &:hover {
        cursor: pointer;

    }
`